import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compact, toLower } from 'lodash';

import Definition from '../../../shared/Definition';

const formatBirthDate = utc => moment(utc).format('DDMMMYY');

const Age = (
    props
) => {
    const {
        age, horseDateOfBirth, horseColourCode, horseSexCode, avgFlatWinDist, isWeatherbysMobile,
    } = props;
    const data = compact([
        horseDateOfBirth && formatBirthDate(horseDateOfBirth),
        toLower(horseColourCode),
        toLower(horseSexCode),
    ]).join(' ');

    if (isWeatherbysMobile) {
        const term = `${age.replace(/-/g, '')} (${data})`;

        return (
            <Definition term={term} isTermLabel={false}>
                {avgFlatWinDist && (
                    <span className="hp-details__info">
                        &nbsp;({avgFlatWinDist}f)
                    </span>
                )}
                {(!avgFlatWinDist && age) && (
                    <span className="hp-details__info" />
                )}
            </Definition>
        );
    }

    return (
        <Definition term={age.replace(/-/g, '')}>
            {data && (
                <span className="hp-details__info">
                    ({data})
                </span>
            )}
            {avgFlatWinDist && (
                <span className="hp-details__info">
                    &nbsp;({avgFlatWinDist}f)
                </span>
            )}
        </Definition>
    );
};

Age.propTypes = {
    age: PropTypes.string,
    horseDateOfBirth: PropTypes.string,
    horseColourCode: PropTypes.string,
    horseSexCode: PropTypes.string,
    avgFlatWinDist: PropTypes.number,
    isWeatherbysMobile: PropTypes.bool,
};

export default Age;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Age.jsx